package com.fantasytenis.shared.data.skills.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Skill leaderboard entry DTO
 */
@Serializable
data class SkillLeaderboardEntryDto(
    @SerialName("playerId") val playerId: String,
    @SerialName("playerName") val playerName: String,
    @SerialName("country") val country: String,
    @SerialName("atpRanking") val atpRanking: Int? = null,
    @SerialName("skillCost") val skillCost: Int,
    @SerialName("skillRank") val skillRank: Int,
    @SerialName("previousCost") val previousCost: Int? = null,
    @SerialName("gender") val gender: String
)

/**
 * Skill leaderboard data wrapper
 */
@Serializable
data class SkillLeaderboardDataDto(
    @SerialName("players") val players: List<SkillLeaderboardEntryDto>,
    @SerialName("total") val total: Int
)

/**
 * Weekly skill snapshot DTO
 */
@Serializable
data class WeeklySkillSnapshotDto(
    @SerialName("weekOf") val weekOf: String,
    @SerialName("serveCost") val serveCost: Int,
    @SerialName("forehandCost") val forehandCost: Int,
    @SerialName("backhandCost") val backhandCost: Int,
    @SerialName("volleysCost") val volleysCost: Int,
    @SerialName("fightingCost") val fightingCost: Int
)

/**
 * Player costs DTO for skill history
 */
@Serializable
data class CurrentCostsDto(
    @SerialName("serve") val serve: Int,
    @SerialName("forehand") val forehand: Int,
    @SerialName("backhand") val backhand: Int,
    @SerialName("volleys") val volleys: Int,
    @SerialName("fighting") val fighting: Int
)

/**
 * Player skill history data DTO
 */
@Serializable
data class PlayerSkillHistoryDataDto(
    @SerialName("playerId") val playerId: String,
    @SerialName("playerName") val playerName: String,
    @SerialName("currentCosts") val currentCosts: CurrentCostsDto,
    @SerialName("history") val history: List<WeeklySkillSnapshotDto> = emptyList()
)

/**
 * Trending player entry DTO
 */
@Serializable
data class TrendingPlayerEntryDto(
    @SerialName("playerId") val playerId: String,
    @SerialName("playerName") val playerName: String,
    @SerialName("country") val country: String,
    @SerialName("atpRanking") val atpRanking: Int? = null,
    @SerialName("category") val category: String,
    @SerialName("currentCost") val currentCost: Int,
    @SerialName("previousCost") val previousCost: Int,
    @SerialName("delta") val delta: Int
)

/**
 * Hidden gem top skill DTO
 */
@Serializable
data class HiddenGemTopSkillDto(
    @SerialName("category") val category: String,
    @SerialName("cost") val cost: Int
)

/**
 * Hidden gem player costs DTO
 */
@Serializable
data class HiddenGemCostsDto(
    @SerialName("serve") val serve: Int,
    @SerialName("forehand") val forehand: Int,
    @SerialName("backhand") val backhand: Int,
    @SerialName("volleys") val volleys: Int,
    @SerialName("fighting") val fighting: Int
)

/**
 * Hidden gem entry DTO
 */
@Serializable
data class HiddenGemEntryDto(
    @SerialName("playerId") val playerId: String,
    @SerialName("playerName") val playerName: String,
    @SerialName("country") val country: String,
    @SerialName("atpRanking") val atpRanking: Int? = null,
    @SerialName("averageCost") val averageCost: Double,
    @SerialName("topSkill") val topSkill: HiddenGemTopSkillDto,
    @SerialName("costs") val costs: HiddenGemCostsDto
)
